module.exports = __webpack_public_path__ + "static/media/start_img.6f2510f6.png";